import { render, staticRenderFns } from "./RolesPermissionsTable.vue?vue&type=template&id=198376e6&scoped=true"
import script from "./RolesPermissionsTable.vue?vue&type=script&lang=js"
export * from "./RolesPermissionsTable.vue?vue&type=script&lang=js"
import style0 from "./RolesPermissionsTable.vue?vue&type=style&index=0&id=198376e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198376e6",
  null
  
)

export default component.exports